import {Badge} from '@mantine/core'

import {fulfillmentStatusColor} from 'src/theme/semantic-colors'

import type {FulfillmentStatus} from './assignment-grouping-utils'

type FulfillmentStatusBadgeProps = {
    status: FulfillmentStatus
}

export function FulfillmentStatusBadge({status}: FulfillmentStatusBadgeProps) {
    const color = fulfillmentStatusColor(status)

    switch (status) {
        case 'met':
            return (
                <Badge color={color} variant="light">
                    Met
                </Badge>
            )
        case 'under':
            return (
                <Badge color={color} variant="light">
                    Under-filled
                </Badge>
            )
        case 'over':
            return <Badge variant="light">Over-filled</Badge>
    }
}
